import styled, { css } from 'styled-components'

import MaskedInput from 'core/components/MaskedInput'
import { variables } from 'core/styles'

const sharedStyles = css`
  font-size: 16px;
  color: ${variables.colorBlack60};
`
const Amount = styled.span`
  display: block;
  ${sharedStyles}
`
const CustomMaskedInput = styled(MaskedInput)`
  display: inline-block;
  border: none;
  border-bottom: 1px solid ${variables.colorBlack30};
  border-radius: 0;
  ${sharedStyles}
`
const Container = styled.div`
  &:not(:first-child) {
    margin-top: 24px;
  }
  & > .amount-input-wrapper,
  & > ${Amount} {
    margin-left: 32px;
  }

  input[type='number']::-webkit-inner-spin-button,
  input[type='number']::-webkit-outer-spin-button {
    margin: 0;
    appearance: none;
  }
`
const RadioLabel = styled.label<{ width?: string }>`
  position: relative;
  box-sizing: border-box;
  ${(p) => (p.width ? `width: ${p.width};` : '')}
  display: inline-block;
  padding-left: 32px;
  font-size: 16px;
  line-height: 20px;
  color: ${variables.colorBlack90};
  cursor: pointer;

  &::before {
    position: absolute;
    top: 50%;
    left: 0;
    box-sizing: border-box;
    width: 20px;
    height: 20px;
    padding: 0;
    content: '';
    border-radius: 100%;
    transform: translateY(-50%);
  }

  &::after {
    position: absolute;
    top: calc(50% - 3.5px);
    left: 7px;
    box-sizing: border-box;
    width: 6px;
    height: 6px;
    padding: 0;
    content: '';
    background-color: ${variables.colorWhite};
    border: none;
    border-radius: 100%;
    transition: all 0.2s ease;
  }
`
const RadioInput = styled.input.attrs({ type: 'radio' })`
  display: none;

  &:disabled + ${RadioLabel} {
    cursor: not-allowed;
  }

  &:checked + ${RadioLabel}::before {
    background-color: ${(p) => p.theme.secondary};
    border: 2px solid ${(p) => p.theme.primary};
  }
  &:not(:checked) + ${RadioLabel}::before {
    background-color: ${variables.colorWhite};
    border: 2px solid ${variables.colorBlack70};
  }
  &:disabled + ${RadioLabel}::before {
    background-color: ${variables.colorBlack20};
    border: 2px solid ${variables.colorBlack20};
  }

  &:checked + ${RadioLabel}::after {
    opacity: 1;
    transform: scale(1);
  }
  &:not(:checked) + ${RadioLabel}::after {
    opacity: 0;
    transform: scale(0);
  }
`

const SubLabel = styled.span`
  display: block;
  margin-left: 32px;
  font-size: 12px;
  font-weight: 500;
  color: ${variables.colorBlack50};
`

export { Amount, CustomMaskedInput, Container, RadioInput, RadioLabel, SubLabel }
